import { Editor } from "@monaco-editor/react";
import { Button, Form, Input, Space } from "antd";
import { useTranslation } from "react-i18next";

import { useGenericFormErrorNotification, useOnFormClose } from "@/hooks/forms";
import { useChain } from "@/hooks/useChain";
import { useFormValidation } from "@/modules/form-validation";
import { SidePanelFooter } from "@/modules/side-panel";

const { useForm } = Form;
const { TextArea } = Input;

const SeverityGridForm = ({
  mutation,
  saveButtonLabel,
  initialValues,
  onMutate = () => undefined,
}) => {
  const [form] = useForm();
  const { t } = useTranslation();

  const onClose = useOnFormClose(form);
  const onMutateSuccess = useChain([onClose, onMutate]);

  useGenericFormErrorNotification(mutation.isError);
  const { validation } = useFormValidation(mutation.isError, mutation.error, [
    "name",
    "description",
    "severity_tree_translation",
  ]);

  // TODO IMP-1217 fix require-await
  // eslint-disable-next-line require-await
  const onSave = async () => {
    const data = {
      name: form.getFieldValue("name"),
      description: form.getFieldValue("description"),
      severity_tree_translation: JSON.parse(
        form.getFieldValue("severity_tree_translation")
      ),
    };

    mutation.mutate(data, { onSuccess: onMutateSuccess });
  };

  return (
    <Form
      id="severityGridForm"
      layout="vertical"
      form={form}
      initialValues={initialValues}
      onFinish={onSave}
    >
      <Form.Item
        name="name"
        label={t("severityGrids:form.name.label")}
        {...validation("name")}
      >
        <Input
          placeholder={t("severityGrids:form.name.label")}
          data-testid="name"
        />
      </Form.Item>
      <Form.Item
        name="description"
        label={t("severityGrids:form.description.label")}
        {...validation("description")}
      >
        <TextArea
          placeholder={t("severityGrids:form.description.label")}
          data-testid="description"
        />
      </Form.Item>
      <Form.Item
        name="severity_tree_translation"
        label={t("severityGrids:form.translation.label")}
        {...validation("severity_tree_translation")}
      >
        <Editor defaultLanguage="json" height="70vh" />
      </Form.Item>
      <SidePanelFooter>
        <Space>
          <Button onClick={onClose}>{t("global:cancel")}</Button>
          <Button
            loading={mutation.isPending}
            type="primary"
            data-testid="submit"
            htmlType="submit"
            form="severityGridForm"
          >
            {saveButtonLabel}
          </Button>
        </Space>
      </SidePanelFooter>
    </Form>
  );
};

export default SeverityGridForm;
